import { AppPageHeader } from '@/components/_common';
import { ListBankSlipQuery } from '@/core/domain/interno/Omie/Omie.types';
import { ExtraFiltersProps } from '@/types/ExtraFiltersProps';

export default function BankSlipsListFilters({
  queryParams,
  setQueryParams,
}: ExtraFiltersProps<ListBankSlipQuery>) {
  return (
    <AppPageHeader
      onSearch={(value) =>
        setQueryParams((prev) => ({ ...prev, search: value }))
      }
      searchValue={queryParams?.search}
    />
  );
}
